import { FiltersTypes } from "@common/types/filters/general";
import { InvoiceColumn } from "@common/types/views/invoiceViews";
import { ViewDensity, ViewType } from "@common/types/views/views";
import { invoicesCloseTemplateViewConfigSchema } from "@common/schemas/close-template-task-view-config.schema";

function invoicesTaskColumns() {
    return [
        { id: InvoiceColumn.LOCK, options: { pin: "left" as const } },
        { id: InvoiceColumn.DATE, options: { pin: "left" as const } },
        { id: InvoiceColumn.EXTERNAL_STATUS },
        { id: InvoiceColumn.INVOICE_NUMBER },
        { id: InvoiceColumn.CUSTOMER },
        { id: InvoiceColumn.INVOICE_DATE },
        { id: InvoiceColumn.DUE_DATE },
        { id: InvoiceColumn.AMOUNT },
        { id: InvoiceColumn.PAID },
        { id: InvoiceColumn.ENTITY, options: { pin: "right" as const } },
        { id: InvoiceColumn.EXTERNAL_LINK, options: { pin: "right" as const } },
    ];
}

export interface CreateInvoicesViewConfigParams {
    filters?: FiltersTypes;
    columns?: ReturnType<typeof invoicesTaskColumns>;
}

/**
 * Default view for an INVOICES task (template, workspace drawer and bulk
 * selection). Selection and bulk actions are on so the task body can act on
 * rows; the creation preview turns them off locally.
 */
export function createInvoicesViewConfig({
    filters = {},
    columns,
}: CreateInvoicesViewConfigParams = {}) {
    return invoicesCloseTemplateViewConfigSchema.parse({
        type: ViewType.INVOICE,
        columns: columns ?? invoicesTaskColumns(),
        filters,
        options: {
            selection: true,
            bulkActions: true,
            density: ViewDensity.MD,
        },
    });
}
